import React, { useState, useEffect } from "react";
import { Table, OverlayTrigger, Tooltip, Nav } from "react-bootstrap";
import moment from "moment";
import Pagination from "../../../../components/Pagination";

const LeaveHistory = ({ leaveHistory, wfhHistory = [], onEdit, showAction, title }) => {
  const [activeTab, setActiveTab] = useState("Leave");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedRecordsPerPage, setSelectedRecordsPerPage] = useState(5);
  // const itemsPerPage = 5;

  const handleRecordsPerPage = (e) => {
    const newRecordsPerPage = Number(e.target.value);

    // Calculate the new starting record index based on the current page
    const currentStartIndex = (currentPage - 1) * selectedRecordsPerPage;
    const newPage = Math.floor(currentStartIndex / newRecordsPerPage) + 1;

    // Update state
    setSelectedRecordsPerPage(newRecordsPerPage);
    setCurrentPage(newPage); // Adjust to the new page based on the same starting record index
    setItemsPerPage(newRecordsPerPage);
  };

  // Reset pagination when tab changes
  useEffect(() => {
     setCurrentPage(1);
  }, [activeTab]);

  const activeData = activeTab === "Leave" ? leaveHistory : wfhHistory;

  const recordsPerPageOption = [
    { value: 5, label: "5" },
    { value: 10, label: "10" },
    { value: 25, label: "25" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
    { value: activeData.length, label: "All" },
  ];

  // Calculate the index of the first and last items on the current page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  // Get current items for the page
  const currentItems = activeData.slice(indexOfFirstItem, indexOfLastItem);

  // Handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <div className="container-fluid" id="skill-table-area">
        <div className="row p-1">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h6 className="mb-0">
              <b>{title}</b>
            </h6>
          </div>
          <Nav variant="pills" className="px-2 mb-2" activeKey={activeTab} onSelect={(k) => setActiveTab(k)}>
            <Nav.Item>
              <Nav.Link 
                eventKey="Leave" 
                className={activeTab === "Leave" ? "fw-bold text-white" : "bg-light text-dark border"}
                style={{ 
                  cursor: "pointer", 
                  borderRadius: "5px 5px 0 0",
                  backgroundColor: activeTab === "Leave" ? "var(--primary-color)" : ""
                }}
              >
                Leave
              </Nav.Link>
            </Nav.Item>
            <Nav.Item className="ms-1">
              <Nav.Link 
                eventKey="WFH/BT" 
                className={activeTab === "WFH/BT" ? "fw-bold text-white" : "bg-light text-dark border"}
                style={{ 
                  cursor: "pointer", 
                  borderRadius: "5px 5px 0 0",
                  backgroundColor: activeTab === "WFH/BT" ? "var(--primary-color)" : ""
                }}
              >
                WFH/BT
              </Nav.Link>
            </Nav.Item>
          </Nav>
          <div className="box-body table-responsive px-2">
            <Table striped bordered hover style={{ tableLayout: "fixed", width: "100%" }}>
              <thead id="thcolor" className="text-center">
                {activeTab === "Leave" ? (
                  <tr>
                    <th className="py-1 px-2" style={{ width: "22%" }}>Applied Date</th>
                    <th className="py-1 px-2" style={{ width: "22%" }}>From Date</th>
                    <th className="py-1 px-2" style={{ width: "22%" }}>To Date</th>
                    <th className="py-1 px-2" style={{ width: "24%" }}>Status</th>
                    {showAction && <th className="py-1 px-2" style={{ width: "10%" }}>Action</th>}
                  </tr>
                ) : (
                  <tr>
                    <th className="py-1 px-2" style={{ width: "20%", whiteSpace: "nowrap" }}>Applied Date</th>
                    <th className="py-1 px-2" style={{ width: "20%", whiteSpace: "nowrap" }}>Type</th>
                    <th className="py-1 px-2" style={{ width: "40%" }}>Dates</th>
                    <th className="py-1 px-2" style={{ width: "12%" }}>Status</th>
                    {showAction && <th className="py-1 px-2" style={{ width: "8%" }}>Action</th>}
                  </tr>
                )}
              </thead>
              <tbody className="text-center">
                {currentItems.length === 0 ? (
                  <tr>
                    <td colSpan={showAction ? "5" : "4"} className="py-1 px-2">
                      No Record
                    </td>
                  </tr>
                ) : (
                  currentItems.map((item, index) => (
                    activeTab === "Leave" ? (
                      <tr key={index}>
                        <td className="py-1 px-2">
                          {item.TXNDate ? moment(item.TXNDate).format("DD-MMM-YYYY") : "-"}
                        </td>
                        <td className="py-1 px-2">
                          {item.FromDate ? moment(item.FromDate).format("DD-MMM-YYYY") : "-"}
                        </td>
                        <td className="py-1 px-2">
                          {item.ToDate ? moment(item.ToDate).format("DD-MMM-YYYY") : "-"}
                        </td>
                        <td className="py-1 px-2">{item.ApplicationStatus}</td>
                        {showAction && (
                          <td className="py-1 px-2">
                            <OverlayTrigger
                              placement="bottom"
                              overlay={
                                item.ApplicationStatus === "Pending" ? (
                                  <Tooltip id="tooltip-bottom">Edit</Tooltip>
                                ) : (
                                  <></>
                                )
                              }
                            >
                              <div
                                className={`me-2 ${
                                  item.ApplicationStatus !== "Pending"
                                    ? "icon-disabled"
                                    : ""
                                }`}
                              >
                                <i
                                  className="bi bi-pencil-square"
                                  onClick={
                                    item.ApplicationStatus === "Pending"
                                      ? () => onEdit(item.ID)
                                      : null
                                  }
                                ></i>
                              </div>
                            </OverlayTrigger>
                          </td>
                        )}
                      </tr>
                    ) : (
                      <tr key={index}>
                        <td className="py-1 px-2" style={{ whiteSpace: "nowrap" }}>
                          {item.grouped_requests && item.grouped_requests.length > 0 && item.grouped_requests[0].created_at 
                            ? moment(item.grouped_requests[0].created_at).format("DD-MMM-YYYY") 
                            : (item.created_at ? moment(item.created_at).format("DD-MMM-YYYY") : moment().format("DD-MMM-YYYY"))}
                        </td>
                        <td className="py-1 px-2" style={{ whiteSpace: "nowrap" }}>
                          {item.request_type}
                        </td>
                        <td className="py-1 px-2">
                          {item.grouped_requests && item.grouped_requests.length > 0 
                            ? (
                                <div className="d-flex flex-wrap justify-content-center gap-1">
                                  {item.grouped_requests
                                    .filter(r => r.request_type !== "Cancel")
                                    .map((r, i) => (
                                    <span key={i} className="badge bg-light text-dark border rounded-pill px-2 py-1 fw-normal">
                                      {moment(r.date || r.from_date).format("DD-MMM-YYYY")}
                                    </span>
                                  ))}
                                </div>
                              )
                            : ((item.date || item.from_date) && item.request_type !== "Cancel" ? <span className="badge bg-light text-dark border rounded-pill px-2 py-1 fw-normal">{moment(item.date || item.from_date).format("DD-MMM-YYYY")}</span> : "-")}
                        </td>
                        <td className="py-1 px-2">{item.status_name}</td>
                        {showAction && (
                          <td className="py-1 px-2">
                            <OverlayTrigger
                              placement="bottom"
                              overlay={
                                item.status_name === "Pending" ? (
                                  <Tooltip id="tooltip-bottom">Edit</Tooltip>
                                ) : (
                                  <></>
                                )
                              }
                            >
                              <div
                                className={`me-2 ${
                                  item.status_name !== "Pending"
                                    ? "icon-disabled"
                                    : ""
                                }`}
                              >
                                <i
                                  className="bi bi-pencil-square"
                                  onClick={
                                    item.status_name === "Pending"
                                      ? () => onEdit(item.grouped_requests)
                                      : null
                                  }
                                ></i>
                              </div>
                            </OverlayTrigger>
                          </td>
                        )}
                      </tr>
                    )
                  ))
                )}
              </tbody>
            </Table>
          </div>
        </div>
        {/* Pagination Component */}
      <div className="d-flex flex-column flex-sm-row align-items-sm-center justify-content-sm-between">
  {/* 1️⃣  Text on the left, per‑page dropdown on the right */}
  <div className="d-flex justify-content-between px-2">
    <span style={{ width:"130px" }}>
      Showing {currentItems.length > 0 ? (currentPage - 1) * selectedRecordsPerPage + 1 : 0} –{" "}
      {Math.min(currentPage * selectedRecordsPerPage, (currentPage - 1) * selectedRecordsPerPage + currentItems.length)} of{" "}
      {activeData.length}
    </span>

   <div style={{ width:"80px" }}>
    <select
      value={selectedRecordsPerPage}
      onChange={handleRecordsPerPage}
      className="form-select form-select-sm ms-2"
    >
      {recordsPerPageOption.map(opt => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
    </div>
  </div>

  {/* 2️⃣  Pagination centred on small screens, right‑aligned ≥ 576 px */}
  <div className="d-flex justify-content-center justify-content-sm-end mt-2 mt-sm-0 w-100">
    <Pagination
      itemsPerPage={selectedRecordsPerPage}
      totalItems={activeData.length}
      currentPage={currentPage}
      onPageChange={handlePageChange}
    />
  </div>
</div>

      </div>
    </>
  );
};

export default LeaveHistory;
